import { SELECTORS } from "../constants.js";

function trapFocus() {
	return {
		restrict: "A",

		link: function(scope, element) {

			element.on("keyup", function(event) {
				if(event.code === "Tab") {

					const children = element[0].querySelectorAll(SELECTORS.TabbableElements);
					const first = children[0];
					const last = children[children.length - 1];

					const onFirstWithShift = event.target === first && event.shiftKey;
					const onLastNoShift = event.target === last && !event.shiftKey;

					if(onFirstWithShift || onLastNoShift) {
						event.preventDefault();
					}
				}
			});

			element.on("keydown", function(event) {
				if(event.code === "Tab") {

					const children = element[0].querySelectorAll(SELECTORS.TabbableElements);
					const first = children[0];
					const last = children[children.length - 1];

					if(event.target === first && event.shiftKey) {
						event.preventDefault();
						last.focus();
					} else if(event.target === last && !event.shiftKey) {
						event.preventDefault();
						first.focus();
					}
				}
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.trap-focus", [])
	.directive("trapFocus", trapFocus).name;
